(function (w) {
    function PrivateSellerRegistrationViewModel(args) {
        let self = this;
        self.FirstName = ko.observable(args.model.FirstName).extend({
            required: true, maxLength: 75,
            pattern: {
                params: /^(?!.*@)(?!.*\(\s*at\s*\)).*$/,
                message: "Please enter a valid name"
            }
        });
        self.LastName = ko.observable(args.model.LastName).extend({
            required: true, maxLength: 75,
            pattern: {
                params: /^(?!.*@)(?!.*\(\s*at\s*\)).*$/,
                message: "Please enter a valid name"
            }
        });
        self.Email = ko.observable(args.model.Email).extend({ required: true, email: true });
        self.Password = ko.observable(args.model.Password).extend({
            required: true, minLength: 8, pattern: {
                message: 'Password must contain at least 1 upper case letter, 1 lower case letter, 1 number and be longer than 8 characters',
                params: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,152}$'
            } });

        self.WantsNewSmsSubscription = ko.observable(false);
        self.DialCodes = ko.observableArray(args.dialCodes);
        self.DialCode = ko.observable();

        self.PhoneNumberLabel = ko.pureComputed(function () {
            return args.CountryCode == 'US' || args.CountryCode == 'CA' ? 'Cell phone number' : 'Mobile phone number';
        });

        self.CanDialCodeSubscribeToSms = ko.pureComputed(function () {
            return self.DialCode() && phoneNumberCheckService.canSubscribeToSmsDialCodes.indexOf('+' + self.DialCode().Value) >= 0;
        });
        self.TelephoneWithDialCode = ko.pureComputed(function () {
            return '+' + (self.DialCode() && self.DialCode().Value ? self.DialCode().Value : '1') + ' ' + self.Telephone();
        });
        self.ShowTelephoneHasToUnsubscribeLabel = ko.pureComputed(function () {
            return args.hasSmsSubscriptions && !self.CanDialCodeSubscribeToSms();
        });
        self.ShowTelephoneChangingLabel = ko.pureComputed(function () {
            return args.hasSmsSubscriptions && self.TelephoneWithDialCode() != args.userTelephone && !self.ShowTelephoneHasToUnsubscribeLabel();
        });
        self.ShowEmailChangingLabel = ko.pureComputed(function () {
            return args.hasEmailSubscriptions && self.Email() != args.userEmail;
        });

        self.Telephone = ko.observable(args.model.Telephone ? args.model.Telephone : '').extend({
            required: {
                message: 'Please enter your phone number'
            },
            validation: {
                validator: function (val, dialCodeParam) {
                    let phoneNumber = ko.unwrap(val);
                    let dialCodeUnwrapped = ko.unwrap(dialCodeParam);
                    let dialCode = dialCodeUnwrapped && dialCodeUnwrapped.Value ? "+" + dialCodeUnwrapped.Value : "";
                    const details = phoneNumberCheckService.getPhoneNumberDetails(dialCode, phoneNumber);
                    return details.Type.indexOf("Mobile") >= 0;
                },
                params: self.DialCode,
                message: function (dialCodeParam, val) {
                    return 'Please enter a valid ' + self.PhoneNumberLabel().toLowerCase();
                },
                onlyIf: function () { return self.CanDialCodeSubscribeToSms() && (args.hasSmsSubscriptions || self.WantsNewSmsSubscription()); }
            },
            pattern: {
                params: /^[\d a-zA-Z\+\-\#\(\)\,\.\\\/]{6,30}$/,
                message: "Please enter a valid phone number"
            }
        });

        self.HasErrors = ko.observable(false);
        self.IsSubmitting = ko.observable(false);
        self.ShowModelStateErrors = ko.observable(false);
        self.EmailAlreadyRegistered = ko.observable(false);

        self.Email.subscribe(function (val) {

            self.ShowModelStateErrors(false);
            self.EmailAlreadyRegistered(false);

            let errors = ko.validation.group(self.Email);
            if (errors().length)
                return;

            if (!val)
                return;

            if (val == args.userEmail) {
                return;
            }

            $.ajax({
                url: args.emailCheckUrl,
                method: 'POST',
                data: { email: val },
                dataType: 'json'
            }).done(function (response) {
                if (val === self.Email() && response && response.registered) {
                    self.EmailAlreadyRegistered(true);
                    Cookies.set('preferences', 'username=' + val, { domain: args.cookieDomain });
                }
            });
        });

        self.Validateables = [{ key: 'FirstName', value: self.FirstName }, { key: 'LastName', value: self.LastName }, { key: 'Email', value: self.Email }, { key: 'Password', value: self.Password }, { key: 'Telephone', value: self.Telephone }];
        self.InvalidKeys = ko.observableArray([]);
        self.RecheckInvalidKeys = function () {
            let invalidKeys = self.InvalidKeys();
            for (let i = invalidKeys.length - 1; i >= 0; i--) {
                let invalidKey = invalidKeys[i];
                for (let j = 0; j < self.Validateables.length; j++) {
                    let validateable = self.Validateables[j];
                    if (validateable.key === invalidKey) {
                        let error = ko.validation.group(validateable.value);
                        if (error().length === 0) {
                            self.InvalidKeys.remove(validateable.key);
                        }
                    }
                }
            }
        }
        for (let i = 0; i < self.Validateables.length; i++) {
            let validateable = self.Validateables[i];
            validateable.value.subscribe(function (val) {
                let error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
                self.RecheckInvalidKeys();
            });
        }
        self.IsInvalid = function (key) {
            return ko.pureComputed(function () { return self.InvalidKeys().indexOf(key) >= 0; });
        };

        self.TrySubmit = function () {

            for (let i = 0; i < self.Validateables.length; i++) {
                let validateable = self.Validateables[i];
                let error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
            }

            let errors = ko.validation.group(self);
            self.HasErrors(errors().length > 0);
            if (self.HasErrors()) {
                errors.showAllMessages();
                setTimeout(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".error").first().offset().top
                    }, 1000);
                }, 100);
                return false;
            }

            setTimeout(function () {
                self.IsSubmitting(true);
            }, 100);
            return true;
        };

        self.InitializeDialCodeAndTelephone = function (telephone) {
            let dialCodes = self.DialCodes();

            // Use the longest matching dial code so +1876 won't get split into +1 and 876...
            if (telephone && telephone.startsWith('+')) {
                let matchedDialCode = null;
                let matchedDialCodeValue = '';
                for (let i = 0; i < dialCodes.length; i++) {
                    let dialCodeValue = dialCodes[i] && dialCodes[i].Value ? dialCodes[i].Value.toString() : '';
                    let dialCodeMatchesCountry = dialCodes[i] && dialCodes[i].CountryCode == args.countryCode;
                    let matchedDialCodeMatchesCountry = matchedDialCode && matchedDialCode.CountryCode == args.countryCode;
                    let isLongerDialCodeMatch = dialCodeValue.length > matchedDialCodeValue.length;
                    let isCountryMatchForSameDialCode = dialCodeValue.length == matchedDialCodeValue.length && dialCodeMatchesCountry && !matchedDialCodeMatchesCountry;
                    if (dialCodeValue && telephone.startsWith('+' + dialCodeValue) && (isLongerDialCodeMatch || isCountryMatchForSameDialCode)) {
                        matchedDialCode = dialCodes[i];
                        matchedDialCodeValue = dialCodeValue;
                    }
                }
                if (matchedDialCode) {
                    self.DialCode(matchedDialCode);
                    self.Telephone(telephone.slice(('+' + matchedDialCodeValue).length).trim());
                }
            }

            // If dial code is not selected yet, set it based on the country
            if (!self.DialCode()) {
                let dialCodeToSelect = self.DialCodes().find(function (x) { return x.CountryCode == args.countryCode; });
                if (dialCodeToSelect) {
                    self.DialCode(dialCodeToSelect);
                }
            }

            // Promote NANP-specific dial codes when a +1 number includes a matching area code
            let selectedDialCode = self.DialCode();
            let selectedDialCodeValue = selectedDialCode && selectedDialCode.Value ? selectedDialCode.Value.toString() : '';
            let nanpDialCodeLookup = phoneNumberCheckService.getNanpDialCodeLookup(dialCodes);
            let promotion = phoneNumberCheckService.tryPromoteNanpDialCode(selectedDialCodeValue, self.Telephone(), nanpDialCodeLookup);
            if (promotion) {
                self.DialCode(promotion.DialCode);
                self.Telephone(promotion.Telephone);
            }
        };
        self.InitializeDialCodeAndTelephone(self.Telephone());
    }
    w.privateSellerRegistrationViewModel = PrivateSellerRegistrationViewModel;
})(window);
